import React from "react";
import CommonWithoutSubscription from "@/pages/att/components/commonNosubscription";
import {useTranslation} from "react-i18next";


const TimeCardWithoutSubscription: React.FC = () => {
  const {t} = useTranslation();

  return (
    <>
      <CommonWithoutSubscription label={t("common.Timecard Advanced Report")}
                                 tips1={t("common.Unlock Timecard Advanced Report")}
                                 tips2={t("common.Get advanced data analysis and exclusive reports.")}
                                 tips3={t("Dashboard.Access all features immediately after subscribing.")}/>
    </>
  )
};

export default TimeCardWithoutSubscription;
